import * as T from '@/core/configs/types'
import cloneDeep from 'lodash/cloneDeep'
import {
  AmazonAddress,
  WalmartAddress,
  UPSAddress,
  FedexAddress,
  OtherAddress,
  US_STATES
} from './constant'
export const AddressBook = {
  id: {
    type: T.String,
    label: 'Address ID',
    key: 'id'
  },
  code: {
    type: T.String,
    label: 'Factory Code',
    key: 'code',
    col: 'code',
    sortable: 'custom'
  },
  name: {
    type: T.String,
    label: 'Name',
    key: 'name',
    col: 'name',
    sortable: 'custom'
  },
  street: {
    type: T.String,
    label: 'Street',
    key: 'street',
    col: 'street',
    sortable: 'custom'
  },
  city: {
    type: T.String,
    label: 'City',
    key: 'city',
    col: 'city',
    sortable: 'custom'
  },
  state: {
    type: T.String,
    label: 'State',
    key: 'state',
    col: 'state',
    sortable: 'custom'
  },
  zip: {
    type: T.String,
    label: 'ZIP Code',
    key: 'zip',
    col: 'zip',
    sortable: 'custom'
  },
  type: {
    type: T.Enum,
    label: 'Address Type',
    key: 'type',
    options: [
      AmazonAddress,
      WalmartAddress,
      UPSAddress,
      FedexAddress,
      OtherAddress
    ],
    col: 'address_type'
  },
  createdTime: {
    type: T.Time,
    label: 'Created on',
    key: 'createdTime',
    col: 'order_created_time'
  },
  updatedTime: {
    type: T.Time,
    label: 'Updated on',
    key: 'updatedTime',
    col: 'order_updated_time'
  }
}

export const AddressTableHeaders = [
  {
    ...AddressBook.code,
    type: T.Link,
    linkKey: AddressBook.id.key,
    link: 'goToAddressDetail'
  },
  {
    ...AddressBook.name,
    width: 80
  },
  {
    ...AddressBook.type,
    type: T.Tag,
    effect: 'plain',
    tagType: 'warn',
    width: 100,
    sortable: 'custom'
  },
  AddressBook.street,
  AddressBook.city,
  AddressBook.state,
  AddressBook.zip
]

export const AddressSearchForm = Object.fromEntries(
  [
    {
      label: 'Factory Code',
      key: 'fuzzyCode',
      type: T.TextInput,
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      label: 'Street',
      key: 'fuzzyStreet',
      type: T.TextInput,
      example: '14950 Valley View Ave',
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      label: 'City',
      key: 'fuzzyCity',
      type: T.TextInput,
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      label: 'State',
      key: 'state',
      type: T.Select,
      default: [],
      value: [],
      validators: [],
      options: US_STATES,
      convertor: T.DefaultConvertor
    },
    ...T.PaginationSearchForm
  ].map(one => [one.key, one])
)

export const AddressSearchParamsWrapUp = searchForm => {
  return T.DefaultWarpSearchForm(searchForm)
}

export const NewAddressForm = [
  {
    label: 'Factory Code',
    key: 'code',
    type: T.TextInput,
    example: 'ONT8',
    span: 1,
    default: '',
    value: '',
    validators: [T.FactoryCodeCheck],
    convertor: T.cleanString
  },
  {
    label: 'Name',
    key: 'name',
    type: T.TextInput,
    example: 'ONT8',
    span: 1,
    default: '',
    value: '',
    validators: [],
    convertor: T.cleanString
  },
  {
    ...AddressBook.type,
    span: 1,
    type: T.Select,
    example: '',
    default: '',
    value: '',
    validators: [T.RequiredValidator],
    convertor: T.cleanString
  },
  {
    label: 'City',
    key: 'city',
    type: T.TextInput,
    span: 1,
    example: 'La Mirada',
    default: '',
    value: '',
    validators: [T.RequiredValidator],
    convertor: T.cleanString
  },
  {
    label: 'State',
    key: 'state',
    type: T.Select,
    span: 1,
    example: 'CA',
    default: '',
    multiple: true,
    value: '',
    validators: [T.RequiredValidator, T.RequiredNotEmptyListValidator],
    options: US_STATES
  },
  {
    label: 'Zip Code',
    key: 'zip',
    span: 1,
    type: T.TextInput,
    example: '90638',
    default: '',
    value: '',
    convertor: T.cleanString,
    validators: [T.ZipCodeCheck, T.RequiredValidator]
  },
  {
    label: 'Street Address',
    key: 'street',
    type: T.TextArea,
    example: '14950 Valley View Ave',
    span: -1,
    default: '',
    value: '',
    validators: [T.RequiredValidator],
    convertor: T.cleanString
  }
]
const AddressnfoPicks = [
  { ...AddressBook.code, type: T.Text, span: 1 },
  { ...AddressBook.name, type: T.Text, span: 1 },
  { ...AddressBook.type, type: T.Tag, effect: 'dark', span: 1 },
  { ...AddressBook.street, type: T.Text, span: 1 },
  { ...AddressBook.city, type: T.Text, span: 1 },
  { ...AddressBook.state, type: T.Text, span: 1 },
  { ...AddressBook.zip, type: T.Text, span: 1 },
  { ...AddressBook.createdTime, type: T.Time, span: 1 },
  { ...AddressBook.updatedTime, type: T.Time, span: 1 }
]

export const AddressInfoWrapUp = T.generateWrapUp(AddressnfoPicks)

export const AddressInfoModifyForm = cloneDeep(NewAddressForm)
